/*
 * Copyright (c) 2025 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, OnInit } from '@angular/core';
import { AuthLogsService } from '../auth-logs.service';
import { AuthLog } from '../shared-auth-logs/auth-log.model';

@Component({
  selector: 'auth-auth-logs',
  templateUrl: './auth-logs.component.html',
  styleUrl: './auth-logs.component.scss',
})
export class AuthLogsComponent implements OnInit{
  authLogs: AuthLog[] | undefined = undefined;
  totalRecords = 10;

  constructor(private readonly authLogsService: AuthLogsService) {}

  ngOnInit() {
    const latestEvent = {
      first: 0,
      rows: 10,
    };
    this.getData(latestEvent);
  }

  loadAuthLogsLazy(event: any) {
    this.getData(event);
  }

  getData(event: any) {
    this.authLogsService.getAuthLogs(event).subscribe((data: any) => {
      this.authLogs = data['_embedded'].entityModels || data['_embedded'].entityModelList;
      this.totalRecords = data['page'].totalElements;
    });
  }
}
